import { FC } from 'react';
import { PARTIAL_ACATS_BASE_PATH } from '../../../helper';
import withTransferForm, { PageIdEnum, TransferFormProps } from '../../../withTransferForm';
import BrokerComp from '../components/Broker';
import { BrokerPageFormutil } from '../type';

const Broker: FC<TransferFormProps<BrokerPageFormutil>> = props => {
    return <BrokerComp {...props} />;
};

export default withTransferForm({
    id: PageIdEnum.BROKER,
    basePath: PARTIAL_ACATS_BASE_PATH,
    step: 1,
    showProgressBar: true,
    //  broker_id变了, 则后面的内容都要清空
    effectExcept: []
})(Broker);
